// 状态数据声明
export const state = {
	'order': {},
	'mweb': {},
	'txAccount': {},
	'payment': {},
	'selectedPkg': {},
	'txAccountList': [],
	'transList': [],
	'selectedPayway': {},
	'payChannels': [],
	'newOrder': {},
	'newCustomer': {},
	'orderListSearch': {
		'searching': false,
		'searchValue': '',
		'searchClass': '',
		'showList': []
	}
}
// 读取状态数据
export const getters = {
	getOrder: state => state.order,
	getMweb: state => state.mweb,
	getTxAccount: state => state.txAccount,
	getPayment: state => state.payment,
	getSelectedPkg: state => state.selectedPkg,
	getAccounts: state => state.txAccountList,
	getTransList: state => state.transList,
	getSelectedPayway: state => state.selectedPayway,
	getPayChannels: state => state.payChannels,
	getNewOrder: state => state.newOrder,
	getNewCustomer: state => state.newCustomer,
	getOrderListSearch: state => state.orderListSearch
}
// 修改状态数据事件
export const actions = {
	setOrder ({ commit, state }, msg) {
		if (typeof msg.order === 'undefined' || typeof msg.order.syn_cms_status === 'undefined') {
			commit('ORDER_SET', { msg })
			return
		}
		if (msg.order.syn_cms_status === 0) {
			commit('SET_LOGO_PATH', 'zytg')
		} else {
			commit('SET_LOGO_PATH', 'yxg')
		}
		commit('ORDER_SET', { msg })
	},
	setNewOrder ({ commit, state }, msg) {
		commit('ORDER_NEW_SET', { msg })
	},
	clearNewOrder ({ commit, state }, msg) {
		commit('ORDER_NEW_CLEAR', { msg })
	},
	setNewCustomer ({ commit, state }, msg) {
		commit('CUSTOMER_NEW_SET', { msg })
	},
	setMweb ({ commit, state }, msg) {
		commit('MWEB_SET', { msg })
	},
	setTxAccount ({ commit, state }, msg) {
		commit('TX_ACCOUNT_SET', { msg })
	},
	setTxAccountList ({ commit, state }, msg) {
		commit('TX_ACCOUNT_LIST_SET', { msg })
	},
	setPayment ({ commit, state }, msg) {
		commit('PAYMENT_SET', { msg })
	},
	clearPayment ({ commit, state }, msg) {
		commit('PAYMENT_CLEAR', { msg })
	},
	setSelectedPkg ({ commit, state }, msg) {
		commit('SELECTED_PKG_SET', { msg })
	},
	setTransList ({ commit, state }, msg) {
		commit('TRANS_LIST_SET', { msg })
	},
	setSelectedPayway ({ commit, state }, msg) {
		commit('SELECTED_PAY_WAY_SET', { msg })
	},
	clearSelectedPayway ({ commit, state }, msg) {
		commit('SELECTED_PAY_WAY_CLEAR', { msg })
	},
	setPayChannels ({ commit, state }, msg) {
		commit('PAY_CHANNELS_SET', { msg })
	},
	setPayChannelSelected ({ commit, state }, msg) {
		commit('PAY_CHANNELS_SELECTED', { msg })
	},
	setOrderListSearch ({ commit, state }, msg) {
		commit('ORDER_LIST_SEARCH_SET', { msg })
	}
}
// 修改状态数据
export const mutations = {
	ORDER_SET (state, { msg }) {
		if (!msg.order || !msg.order.order_no) {
			state.order = {}
		} else {
			state.order = {}
			Object.assign(state.order, msg.order)
		}
		console.log('ORDER_SET:', state.order)
	},
	CUSTOMER_NEW_SET (state, { msg }) {
		if (!msg.customer || !msg.customer.dikou) {
			state.newCustomer = {}
		} else {
			Object.assign(state.newCustomer, msg.customer)
		}
	},
	ORDER_NEW_SET (state, { msg }) {
		Object.assign(state.newOrder, msg.order)
	},
	ORDER_NEW_CLEAR (state, { msg }) {
		state.newOrder = {}
	},
	MWEB_SET (state, { msg }) {
		state.mweb = {}
		Object.assign(state.mweb, msg.mweb)
	},
	TX_ACCOUNT_SET (state, { msg }) {
		Object.assign(state.txAccount, msg.txAccount)
	},
	TX_ACCOUNT_LIST_SET (state, { msg }) {
		state.txAccountList = msg.items
	},
	TRANS_LIST_SET (state, { msg }) {
		state.transList = []
		state.transList = msg.items.slice(0)
	},
	PAYMENT_SET (state, { msg }) {
		Object.assign(state.payment, msg.payment)
	},
	PAYMENT_CLEAR (state, { msg }) {
		state.payment = {}
	},
	SELECTED_PKG_SET (state, { msg }) {
		Object.assign(state.selectedPkg, msg.selectedPkg)
	},
	SELECTED_PAY_WAY_SET (state, { msg }) {
		Object.assign(state.selectedPayway, msg.item)
	},
	SELECTED_PAY_WAY_CLEAR (state, { msg }) {
		state.selectedPayway = {}
	},
	PAY_CHANNELS_SET (state, { msg }) {
		msg.items.forEach(function (item) {
			item.checked = false
			item.checkImage = '/static/img/pay-check.jpg'
		}, this)
		state.payChannels = msg.items
	},
	PAY_CHANNELS_SELECTED (state, { msg }) {
		state.payChannels.forEach(function (item) {
			if (msg.item && msg.item.name === item.name) {
				item.checked = true
				item.checkImage = '/static/img/pay-checked.jpg'
			} else {
				item.checked = false
				item.checkImage = '/static/img/pay-check.jpg'
			}
		}, this)
	},
	ORDER_LIST_SEARCH_SET (state, { msg }) {
		Object.assign(state.orderListSearch, msg.orderListSearch)
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/order.js